export default "__VITE_ASSET__Byvw8sPx__"